import React from "react";
import { Box } from "@material-ui/core";
import Text from "../Text";

export default function PlotAxisLabels(props) {
  const k = props.canvassize[0] < 460 ? 2 : 1; //every 5 years is a bit much on supersmall

  //const N = props.time_axis.last_year - props.time_axis.first_year + 1;
  const N = props.time_axis.last_year - props.time_axis.first_year; //actually, skip the last one
  const v = Array.from(Array(N).keys());
  const labels = v.map((i) =>
    i % (5 * k) === 0 ? props.time_axis.first_year + i : ""
  );

  return (
    <div>
      {labels.map((label, i) => (
        <Box
          key={i}
          bgcolor="transparent"
          width={props.yearwidth_pixels}
          display="inline-block"
        >
          <Text.Sub1>{label}</Text.Sub1>
        </Box>
      ))}
    </div>
  );
}
